<template>
  <!-- Need to add height inherit because Vue 2 don't support multiple root ele -->
    <div style="height: inherit" class="setup fee">
        <table-and-header
            :fee-list= "fees"
            :is-fetching-data= "isFetchingData"
            @addNewFee = "handleFeeCreateOrEdit"
            @editFee="handleFeeCreateOrEdit"
        />

        <create-or-edit
            ref="createOrEditFee"
            v-model="isFeeHandlerSidebarActive"
            :fee="fee"
            :is-fee-view = "isFeeView"
            :clear-fee-data="clearFeeData"
            :data-sidebar-action-loading="isButtonActionLoading"
            @add-fee="addFee"
            @update-fee="updateFee"
            @cancelView = "cancelView"
        />
    </div>
</template>

<script>
import {
    ref, watch, computed,
} from '@vue/composition-api';
import { formatDate, avatarText } from '@core/utils/filter';
import { useRouter } from '@core/utils/utils';
import Fee from '@/models/Fee';
import { errorToast, successToast } from "@/views/helpers/toast";
import { SOMETHING_WENT_WRONG } from '@/constants/errors';
import { FEE_CREATE_SUCCESS, FEE_UPDATE_SUCCESS } from '@/constants/success';
import TableAndHeader from './TableAndHeader.vue';
import CreateOrEdit from './CreateOrEdit.vue';
import { formatPrice } from '@/helpers';

export default {
    components: {
        // App SFC
        CreateOrEdit,
        TableAndHeader,
    },

    setup() {
        const { route, router } = useRouter();
        const routeParams = computed(() => route.value.params);

        watch(routeParams, () => {
            // eslint-disable-next-line no-use-before-define
            fetchFee();
        });

        const fees = ref([]);
        const isFeeView = ref(false);
        const isFetchingData = ref(false);
        const natureOptions = ref([]);
        const isFeeHandlerSidebarActive = ref(false);
        const isButtonActionLoading = ref(false);

        const feeBluePrint = {
            id          : undefined,
            name        : undefined,
            amount      : undefined,
            duration    : undefined,
            service     : undefined,
            nature      : undefined,
        };

        const fee = ref(JSON.parse(JSON.stringify(feeBluePrint)));

        const clearFeeData = () => {
            fee.value = JSON.parse(JSON.stringify(feeBluePrint));
        };

        const setFee = dataFee => ({
            id          : dataFee.id,
            name        : dataFee.name,
            amount      : formatPrice(dataFee.price),
            duration    : dataFee.duration,
            service     : dataFee.service,
            nature      : dataFee.nature
        });

        const addFee = newFee => {
            isButtonActionLoading.value = true;

            Fee
                .create(newFee)
                .then(payload => {
                    fees.value.push(setFee(payload));

                    successToast(FEE_CREATE_SUCCESS);
                    isButtonActionLoading.value = false;
                    isFeeHandlerSidebarActive.value = false;
                })
                .catch(e => {
                    errorToast(SOMETHING_WENT_WRONG);
                    isButtonActionLoading.value = false;

                    console.error(
                        "error while trying to store fee in setup",
                        e
                    );
                });

            setTimeout(()=>{
                clearFeeData();
            }, 1000);
        };

        const updateFee = feeUpdate => {
            isButtonActionLoading.value = true;

            Fee.update(feeUpdate.id, feeUpdate)
                .then(() => {
                    fees.value.forEach(existingFee => {
                        if (existingFee.id === feeUpdate.id) {
                            Object.keys(feeBluePrint).forEach(key => {
                                if (key === 'amount')
                                {
                                    // // eslint-disable-next-line radix
                                    // const price = parseInt(feeUpdate[key]);
                                    // // eslint-disable-next-line no-param-reassign
                                    // existingFee[key] = price.toLocaleString();

                                    // eslint-disable-next-line no-param-reassign
                                    existingFee[key] = formatPrice(feeUpdate[key]);
                                } else {
                                    // eslint-disable-next-line no-param-reassign
                                    existingFee[key] = feeUpdate[key];
                                }
                            });
                        }
                    });

                    successToast(FEE_UPDATE_SUCCESS);
                    isFeeHandlerSidebarActive.value = false;
                    isButtonActionLoading.value = false;
                })
                .catch(e => {
                    errorToast(SOMETHING_WENT_WRONG);
                    isButtonActionLoading.value = false;

                    console.error(
                        "error while trying to update fee in setup",
                        e
                    );
                });
        };

        const cancelView = () =>{
            setTimeout(() => {
                isFeeView.value = false;
            }, 500);
        };

        const perfectScrollbarSettings = {
            maxScrollbarLength: 150,
        };

        // eslint-disable-next-line no-use-before-define
        const updateRouteQuery = val => {
            const currentRouteQuery = JSON.parse(JSON.stringify(route.value.query));

            if (val) currentRouteQuery.q = val;
            else delete currentRouteQuery.q;

            router.replace({ name: route.name, query: currentRouteQuery });
        };

        const fetchFee = async() => {
            isFetchingData.value = true;

            const feeLists = await Fee.all();

            feeLists.forEach(dataFee =>{
                fees.value.push(setFee(dataFee));
            });

            isFetchingData.value = false;
        };

        fetchFee();

        const handleFeeCreateOrEdit = (toEditOrViewFee= feeBluePrint, status= "create") => {
            if(status === 'create') {
                fee.value = feeBluePrint;
            }
            else if(status === 'view') {
                isFeeView.value = true;
                fee.value = toEditOrViewFee.item;
            }
            else fee.value = toEditOrViewFee.item;

            isFeeHandlerSidebarActive.value = true;
        };

        return {
            fee,
            fees,
            addFee,
            updateFee,
            clearFeeData,
            fetchFee,
            perfectScrollbarSettings,
            updateRouteQuery,
            natureOptions,
            isFeeView,
            cancelView,

            // Click Handler
            handleFeeCreateOrEdit,

            // Filters
            formatDate,
            avatarText,
            isFetchingData,

            isFeeHandlerSidebarActive,
            isButtonActionLoading
        };
    },
};
</script>

<style lang="scss">
@import "~@core/scss/base/pages/app-todo.scss";
</style>
